import { useMutation } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { UpdatePasswordBody } from '@/types'
import { MutationOptions } from '@/api/react-query'

export async function updatePassword(body: UpdatePasswordBody) {
  const response = await httpClient('user-manager').put(
    '/v1/user/me/password',
    body,
  )

  return response.data
}

export function useUpdatePassword(
  options?: MutationOptions<unknown, UpdatePasswordBody>,
) {
  return useMutation({
    mutationFn: updatePassword,
    ...options,
  })
}
